import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

/**
 * Grafik ranglari CSS o'zgaruvchilarida turadi (`index.css`), lekin
 * Recharts ularni SVG ATRIBUTI sifatida yozadi — `fill="var(--chart-1)"`
 * atributda hal qilinmaydi va rang qora bo'lib chiqadi.
 *
 * Shu sababli qiymatlarni `getComputedStyle` orqali o'qiymiz va mavzu
 * almashganda qayta o'qiymiz. Bitta manba (CSS) saqlanadi, Recharts esa
 * tayyor rang oladi.
 */
const TOKENS = [
  "--chart-1",
  "--chart-2",
  "--chart-3",
  "--chart-4",
  "--chart-5",
  "--muted-foreground",
  "--border",
  "--destructive",
  "--card",
] as const;

export type ChartColors = Record<(typeof TOKENS)[number], string>;

const read = (): ChartColors => {
  const styles = getComputedStyle(document.documentElement);
  return Object.fromEntries(
    TOKENS.map(token => [token, styles.getPropertyValue(token).trim()]),
  ) as ChartColors;
};

export function useChartColors(): ChartColors | null {
  const { resolvedTheme } = useTheme();
  const [colors, setColors] = useState<ChartColors | null>(null);

  useEffect(() => {
    // Mavzu klassi DOM ga qo'yilgandan KEYIN o'qish kerak, aks holda
    // eski rejimning ranglari olinadi.
    const id = requestAnimationFrame(() => setColors(read()));
    return () => cancelAnimationFrame(id);
  }, [resolvedTheme]);

  return colors;
}
